<template>
  <b-modal
    hide-footer
    size="xl"
    title="Add League Pricekinetic"
    centered
    id="league-pricekinetic"
  >
    <div class="container-league text-black">
      <b-row>
        <b-col cols="12" class="mb-2">
          <div class="d-flex justify-content-end align-items-center">
            <b-button
              variant="outline-secondary"
              class="mr-1"
              @click="handleBack"
              >Cancel</b-button
            >
            <b-button
              @click="handleSubmitCreateLeague"
              :disabled="loadingCreateLeague"
              variant="success"
            >
              <feather-icon icon="PlusIcon" />
              <Spinner v-if="loadingCreateLeague" />
              <template v-else> Create League </template>
            </b-button>
          </div>
        </b-col>

        <b-col cols="12">
          <b-card no-body class="mb-4">
            <b-card-header class="bg-dark text-white p-1">
              🏆 League Management
            </b-card-header>
            <b-card-body>
              <h5 class="mt-1 mb-1 text-body font-weight-bold">
                Create Sports League
              </h5>

              <b-form>
                <b-row>
                  <b-col md="4">
                    <b-form-group>
                      <span class="font-weight-bold">Icon:</span>
                      <b-form-input
                        v-model="form.icon"
                        placeholder="Enter icon link..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <span class="font-weight-bold">Order:</span>
                      <b-form-input
                        v-model="form.order"
                        :formatter="formatPrice"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <span class="font-weight-bold">Tier:</span>
                      <b-form-select
                        v-model="form.tier"
                        :options="tierOptions"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- <b-form-group>
                  <span class="font-weight-bold">League Code:</span>
                  <b-form-input
                    v-model="form.code"
                    placeholder="Eg. american_football"
                  ></b-form-input>
                </b-form-group> -->

                <b-form-group>
                  <label class="font-weight-bold text-warning">Name:</label>
                  <b-form-input
                    v-model="form.name"
                    placeholder="Enter league name (e.g., AFL, NRL, NBA)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Short Name:</span>
                  <b-form-input
                    v-model="form.shortName"
                    placeholder="Short version (e.g., AFL, NRL)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Official Name:</span>
                  <b-form-input
                    v-model="form.officialName"
                    placeholder="Official league name"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <span class="font-weight-bold">Description:</span>
                  <b-form-textarea
                    v-model="form.description"
                    placeholder="League description and additional details"
                  ></b-form-textarea>
                </b-form-group>

                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Display:</span>
                      <b-form-radio-group
                        v-model="form.display"
                        :options="yesNoOptions"
                        name="display-options"
                        class="mt-1"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <span class="font-weight-bold">Featured League:</span>
                      <b-form-radio-group
                        v-model="form.featured"
                        :options="yesNoOptions"
                        name="featured-options"
                        class="mt-1"
                      ></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>

          <b-card no-body class="mb-4">
            <b-card-header class="bg-dark text-white p-1">
              League Details
            </b-card-header>
            <b-card-body>
              <b-row class="mt-2">
                <b-col md="6">
                  <b-form-group>
                    <p class="font-weight-bold mb-0">
                      Country: <span class="text-danger">*</span>
                    </p>
                    <b-form-select
                      v-model="form.country"
                      :options="countryOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Region:</span>
                    <b-form-select
                      v-model="form.region"
                      :options="regionOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <p class="font-weight-bold mb-0">
                      Season: <span class="text-danger">*</span>
                    </p>
                    <b-form-input
                      v-model="form.season"
                      placeholder="2024/25"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Competition Type:</span>
                    <b-form-select
                      v-model="form.competitionType"
                      :options="competitionOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Max Teams:</span>
                    <b-form-input
                      v-model="form.maxTeam"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Status:</span>
                    <b-form-select
                      v-model="form.status"
                      :options="statusOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Season Start Date:</span>
                    <flat-pickr
                      id="startDate"
                      v-model="form.seasonStartDate"
                      class="form-control"
                      :config="configDate"
                      placeholder="mm/dd/yyyy"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Season End Date:</span>
                    <flat-pickr
                      id="startDate"
                      v-model="form.seasonEndDate"
                      class="form-control"
                      :config="configDate"
                      placeholder="mm/dd/yyyy"
                    />
                  </b-form-group>
                </b-col>

                <!-- League Configuration -->
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12">
          <b-card no-body class="mb-4">
            <b-card-header
              class="text-white p-1 mb-1"
              style="background-color: #007bff"
            >
              League Configuration
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Timezone:</span>
                    <b-form-select
                      v-model="formLeague.timeZone"
                      :options="timezoneOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Currency:</span>
                    <b-form-select
                      v-model="formLeague.currency"
                      :options="currencyOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Official Website:</span>
                    <b-form-input
                      v-model="formLeague.officalWebsite"
                      placeholder="https://www.league-website.com"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <span class="font-weight-bold">Governing Body:</span>
                    <b-form-input
                      v-model="formLeague.governingBody"
                      placeholder="e.g., AFL Commission, NRL"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group>
                <span class="font-weight-bold">Sponsors/Partners:</span>
                <b-form-textarea
                  v-model="formLeague.sponspors"
                  placeholder="List major sponsors and partners"
                  rows="2"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group>
                <span class="font-weight-bold">Broadcast Rights:</span>
                <b-form-input
                  v-model="formLeague.broadcastRights"
                  placeholder="e.g., Fox Sports, ESPN, Sky Sports"
                ></b-form-input>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12">
          <b-card no-body>
            <b-card-header
              class="text-white p-1"
              style="background-color: #9c27b0"
            >
              Default League Settings
            </b-card-header>
            <b-card-body>
              <b-row class="mt-2">
                <b-col
                  v-for="(option, index) in defaultSettingsOptions"
                  :key="index"
                  md="4"
                  class="mt-1"
                >
                  <b-form-checkbox
                    v-model="formLeague.defaultSettings"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col cols="12">
          <div class="d-flex justify-content-end">
            <b-button variant="secondary" class="mr-1" @click="handleBack"
              >Cancel</b-button
            >
            <template>
              <b-button
                @click="handleSubmitCreateLeague"
                variant="success"
                :disabled="loadingCreateLeague"
              >
                <Spinner v-if="loadingCreateLeague" />
                <template v-else> Create League </template>
              </b-button>
            </template>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapState } from "vuex";
import Spinner from "@/@core/components/Spinner.vue";
import useToastHandler from "@/services/toastHandler";
import { stringProp } from "@/helpers/props";

export default {
  props: {
    selectedSport: stringProp(),
  },
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    flatPickr,
    Spinner,
  },
  data() {
    return {
      leagueItem: null,
      form: {
        icon: "",
        code: "",
        order: null,
        tier: null,
        name: "",
        shortName: "",
        officialName: "",
        description: "",
        display: false,
        featured: false,
        country: "",
        region: "",
        season: "",
        competitionType: "",
        maxTeam: null,
        seasonStartDate: null,
        seasonEndDate: null,
      },
      yesNoOptions: [
        { value: false, text: "No" },
        { value: true, text: "Yes" },
      ],
      iconOptions: [
        { value: "🏆", text: "🏆 Default League" },
        { value: "🏀", text: "🏀 Basketball" },
        { value: "⚽", text: "⚽ Football" },
      ],
      tierOptions: [
        { value: 1, text: "Tier 1" },
        { value: 2, text: "Tier 2" },
        { value: 3, text: "Tier 3" },
      ],
      countryOptions: [
        { value: "Australia", text: "Australia" },
        { value: "New Zealand", text: "New Zealand" },
        { value: "United States", text: "United States" },
        { value: "United Kingdom", text: "United Kingdom" },
        { value: "Canada", text: "Canada" },
      ],
      regionOptions: [
        { value: "Australia", text: "Australia" },
        { value: "Oceania", text: "Oceania" },
        { value: "North America", text: "North America" },
        { value: "Europe", text: "Europe" },
        { value: "Asia", text: "Asia" },
      ],
      competitionOptions: [
        { value: "League", text: "League" },
        { value: "Cup", text: "Cup" },
        { value: "Tournament", text: "Tournament" },
        { value: "Championship", text: "Championship" },
        { value: "Series", text: "Series" },
      ],
      statusOptions: [
        { value: "Active", text: "Active" },
        { value: "Inactive", text: "Inactive" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      timezoneOptions: [
        { value: "AEST", text: "AEST (Australian Eastern)" },
        { value: "GMT", text: "GMT" },
        { value: "UTC", text: "UTC" },
      ],
      currencyOptions: [
        { value: "AUD", text: "AUD (Australian Dollar)" },
        { value: "USD", text: "USD (US Dollar)" },
        { value: "EUR", text: "EUR (Euro)" },
      ],
      defaultSettingsOptions: [
        { value: "allowDraw", text: "Allow Draws" },
        { value: "allowOverTime", text: "Overtime/Extra Time" },
        { value: "isPlayoff", text: "Playoffs/Finals" },
        { value: "allowLiveBetting", text: "Live Betting" },
        { value: "allowCashOut", text: "Cash Out" },
        { value: "allowLiveStreaming", text: "Live Streaming" },
      ],
      formLeague: {
        timeZone: "AEST",
        currency: "AUD",
        officalWebsite: "",
        governingBody: "",
        sponspors: "",
        broadcastRights: "",
        defaultSettings: [],
      },
    };
  },
  async created() {},
  computed: {
    ...mapState("sport/create", ["loadingCreateLeague"]),
  },
  methods: {
    ...mapActions({
      createLeague: "sport/create/createLeague",
    }),
    formatPrice(value) {
      value = value.replace(/[^0-9.]/g, "");

      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      if (value.includes(".")) {
        const decimalPart = value.split(".")[1];
        if (decimalPart.length > 2) {
          const integerPart = value.split(".")[0];
          value = `${integerPart}.${decimalPart.slice(0, 2)}`;
        }
      }

      return value;
    },
      handleBack() {
      this.resetData();
      this.$bvModal.hide("league-pricekinetic");
    },
    async handleSubmitCreateLeague() {
      const res = await this.createLeague({
        name: this.form.name,
        shortName: this.form.shortName,
        officialName: this.form.officialName,
        description: this.form.description,
        code: this.selectedSport.code,
        logo: this.form.icon,
        orderNumber: Number(this.form.order),
        tier: Number(this.form.tier),
        source: "pricekinetic",
        status: this.form.display ? "active" : "disabled",
        sportId: this.selectedSport.id,
        isLeagueFeatured: this.form.featured,
        sportLeagueAdvance: {
          country: this.form.country,
          region: this.form.region,
          season: this.form.season,
          competitionType: this.form.competitionType,
          maxTeam: Number(this.form.maxTeam),
          seasonStartDate: this.form.seasonStartDate,
          seasonEndDate: this.form.seasonEndDate,
          timeZone: this.formLeague.timeZone,
          currency: this.formLeague.currency,
          officalWebsite: this.formLeague.officalWebsite,
          governingBody: this.formLeague.governingBody,
          sponspors: this.formLeague.sponspors,
          broadcastRights: this.formLeague.broadcastRights,
          allowLiveBetting: this.formLeague.defaultSettings.some(
            (i) => i === "allowLiveBetting"
          ),
          allowCashOut: this.formLeague.defaultSettings.some(
            (i) => i === "allowCashOut"
          ),
          allowLiveStreaming: this.formLeague.defaultSettings.some(
            (i) => i === "allowLiveStreaming"
          ),
          allowDraw: this.formLeague.defaultSettings.some(
            (i) => i === "allowDraw"
          ),
          allowOverTime: this.formLeague.defaultSettings.some(
            (i) => i === "allowOverTime"
          ),
          isPlayoff: this.formLeague.defaultSettings.some(
            (i) => i === "isPlayoff"
          ),
        },
      });
      if (res) {
        this.showToastSuccess(true, "New league created successfully!");
        this.$emit("refresh");
        this.handleBack();
      }
    },
    resetData() {
      this.leagueItem = null;
      this.form = {
        icon: "🏆",
        code: "",
        order: 0,
        tier: null,
        name: "",
        shortName: "",
        officialName: "",
        description: "",
        display: false,
        featured: false,
        country: "",
        region: "",
        season: "",
        competitionType: "",
        maxTeam: null,
        seasonStartDate: null,
        seasonEndDate: null,
      };
      this.formLeague = {
        timeZone: "AEST",
        currency: "AUD",
        officalWebsite: "",
        governingBody: "",
        sponspors: "",
        broadcastRights: "",
        defaultSettings: [],
      };
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();
    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss" scoped>
.container-league {
  max-width: 1024px;
  margin: auto;
  padding: 16px;
}
</style>
